// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__buttonContainer___H0oHc {
    text-align: center;
}

.style__getStartedButton___wdL45 {
    display: inline-block;
    background: linear-gradient(to right, var(--secondaryB-color), var(--secondaryA-color));
    color: #ffffff;
    padding: 12px 28px;
    border: none;
    border-radius: 40px;
    font-size: 18px;
    text-decoration: none;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease, box-shadow 0.2s ease, background-position 0.2s;
}

.style__getStartedButton___wdL45:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
    background-position: right center;
}


.style__getStartedButton___wdL45:active {
    transform: scale(0.95);
}

.style__getStartedButton___wdL45:focus {
    outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Buttons/AnimatedButton/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,uFAAuF;IACvF,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,wCAAwC;IACxC,+EAA+E;AACnF;;AAEA;IACI,sBAAsB;IACtB,0CAA0C;IAC1C,iCAAiC;AACrC;;;AAGA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".buttonContainer {\n    text-align: center;\n}\n\n.getStartedButton {\n    display: inline-block;\n    background: linear-gradient(to right, var(--secondaryB-color), var(--secondaryA-color));\n    color: #ffffff;\n    padding: 12px 28px;\n    border: none;\n    border-radius: 40px;\n    font-size: 18px;\n    text-decoration: none;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    transition: transform 0.2s ease, box-shadow 0.2s ease, background-position 0.2s;\n}\n\n.getStartedButton:hover {\n    transform: scale(1.05);\n    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);\n    background-position: right center;\n}\n\n\n.getStartedButton:active {\n    transform: scale(0.95);\n}\n\n.getStartedButton:focus {\n    outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonContainer": `style__buttonContainer___H0oHc`,
	"getStartedButton": `style__getStartedButton___wdL45`
};
export default ___CSS_LOADER_EXPORT___;
